export enum MainRoutes {
  home = '',
  acceso = '',
  resetPassword = 'resetPassword',
  reenvioMail = 'reenvioMail',
  error = 'error',
  verificationExpired = 'verification-link-expired',
}
